var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg20Copy(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 3.75C1 2.23122 2.23122 1 3.75 1H12.25C13.7688 1 15 2.23122 15 3.75V5H16.25C17.7688 5 19 6.23122 19 7.75V16.25C19 17.7688 17.7688 19 16.25 19H7.75C6.23122 19 5 17.7688 5 16.25V15H3.75C2.23122 15 1 13.7688 1 12.25V3.75ZM5 13.5V7.75C5 6.23122 6.23122 5 7.75 5H13.5V3.75C13.5 3.05964 12.9404 2.5 12.25 2.5H3.75C3.05964 2.5 2.5 3.05964 2.5 3.75V12.25C2.5 12.9404 3.05964 13.5 3.75 13.5H5ZM7.75 6.5C7.05964 6.5 6.5 7.05964 6.5 7.75V16.25C6.5 16.9404 7.05964 17.5 7.75 17.5H16.25C16.9404 17.5 17.5 16.9404 17.5 16.25V7.75C17.5 7.05964 16.9404 6.5 16.25 6.5H7.75Z",
    fill: "#182BCF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg20Copy);
export default __webpack_public_path__ + "static/media/20-copy.cf7b0b1fa02c90e731ee8d3fa66bb8df.svg";
export { ForwardRef as ReactComponent };